import { Redirect } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { resetSnackbar } from '../../redux/snackbar'
import {
  Stepper,
  StepOne,
  StepTwo,
  StepThree,
  StepFour,
  CaseSended,
  CaseSendedNotReferible,
  Snackbar
} from '../../components'
import { stepContinue, stepNotContinue } from '../../redux/steps'
import { setReferableCases, setNonReferableCases, setResetCases } from '../../redux/cases'
import { setEvaluations } from '../../redux/evaluations'
import { USER_STATUS } from '../../const'
import { Container } from './styles'
import { useEffect } from 'react'
import CaseSendedReferableNotReferred from '../../components/NewCaseSteps/CaseSendedReferableNotReferred'
import CaseSendedNonReferableReferred from '../../components/NewCaseSteps/CaseSendedNonReferableReferred'
import CaseSendedNonReferableSampled from '../../components/NewCaseSteps/CaseSendedNonReferableSampled'
import { FINAL_CASES } from '../../components/NewCaseSteps/StepFour/AnalysisResult/helpers'

const STEPS_VIEW = {
  1: StepOne,
  2: StepTwo,
  3: StepThree,
  4: StepFour
}

const TECHNICAL_STEP_FOUR_STATES = ['diagnosticando', 'diagnosticado referible', 'diagnosticado no referible']
const DIAGNOSIS_IN_FLIGHT_STORAGE_KEY = '_dx_in_flight'

export function NewCase () {
  const { steps, snackbar, user, evaluations } = useSelector(state => state)
  const dispatch = useDispatch()

  if (user.status === USER_STATUS.LOCKED || user.role === 'ophthalmologist') return <Redirect to='/home' />

  const handleCloseSnackbar = () => {
    dispatch(resetSnackbar())
  }

  useEffect(() => {
    if (Object.keys(evaluations).length) {
      dispatch(stepContinue())
      if (
        evaluations.estado === 'diagnosticado referible' ||
        evaluations.estado === 'diagnosticado no referible'
      ) {
        if (evaluations.resumen_DX_IA === true) {
          dispatch(setReferableCases())
        } else if (evaluations.resumen_DX_IA === false) {
          dispatch(setNonReferableCases())
        }
      } else if (evaluations.estado === 'diagnosticando') {
        dispatch(setResetCases())
      }
      return
    }

    const diagnosisInFlightRaw = sessionStorage.getItem(DIAGNOSIS_IN_FLIGHT_STORAGE_KEY)
    if (diagnosisInFlightRaw) {
      try {
        const diagnosisInFlight = JSON.parse(diagnosisInFlightRaw)
        if (diagnosisInFlight && diagnosisInFlight.studyId) {
          dispatch(setEvaluations({ id: diagnosisInFlight.studyId, estado: 'diagnosticando' }))
          dispatch(stepContinue())
          dispatch(setResetCases())
          return
        }
      } catch (error) {
        console.error('No se pudo recuperar el estudio en diagnóstico desde la sesión:', error)
        sessionStorage.removeItem(DIAGNOSIS_IN_FLIGHT_STORAGE_KEY)
      }
    }

    dispatch(stepNotContinue())
  }, [])

  const shouldRenderStepFour = TECHNICAL_STEP_FOUR_STATES.includes(evaluations.estado)

  const CurrentStepView = STEPS_VIEW[steps.current] || <h1> Step sin datos! <br /> Step: {steps.current} </h1>

  return (
    <Container>
      {snackbar.active && (
        <Snackbar status={snackbar.status} close={handleCloseSnackbar}>
          {snackbar.text}
        </Snackbar>
      )}

      {!steps.continue && <Stepper />}
      {steps.completed
        ? steps.finalCase === FINAL_CASES[1]
            ? <CaseSendedReferableNotReferred />
            : steps.finalCase === FINAL_CASES[2]
              ? <CaseSendedNonReferableReferred />
              : steps.finalCase === FINAL_CASES[3]
                ? <CaseSendedNotReferible />
                : steps.finalCase === FINAL_CASES[4]
                  ? <CaseSendedNonReferableSampled />
                  : <CaseSended />
        : steps.continue
          ? shouldRenderStepFour
              ? <StepFour />
              : <StepThree />
          : <CurrentStepView />}

    </Container>
  )
}

export default NewCase
